// extracted by mini-css-extract-plugin
module.exports = {"titleItem":"index_titleItem__9M_rm","delete":"index_delete__ZzuoG","modalContainer":"index_modalContainer__aYiHi","ulContent":"index_ulContent__Ckwxy"};